import {
    cloneReportConfigurationReport,
    createReportConfigurationFolder,
    createReportConfigurationReport,
    deleteReportConfigurationFolder,
    deleteReportConfigurationReport,
    getReportConfigurationReportPlan,
    updateReportConfigurationFolder,
    updateReportConfigurationReport,
} from "../../../../service/httpsCalls";
import type {
    CloneReportConfigurationReportPayload,
    CloneReportConfigurationReportResultDto,
    ReportConfigurationReportDto,
    ReportConfigurationReportFolderDto,
    ReportConfigurationReportPlanDto,
} from "../types";

export const loadReportPlan = (clientId: number, signal?: AbortSignal) =>
    getReportConfigurationReportPlan(clientId, signal) as Promise<ReportConfigurationReportPlanDto>;

export const createReportFolder = (reportPlanId: number, label: string) =>
    createReportConfigurationFolder(reportPlanId, label) as Promise<ReportConfigurationReportFolderDto>;

export const updateReportFolder = (reportFolderId: number, label: string) =>
    updateReportConfigurationFolder(reportFolderId, label) as Promise<ReportConfigurationReportFolderDto>;

export const deleteReportFolder = (reportFolderId: number) =>
    deleteReportConfigurationFolder(reportFolderId);

export const createReport = (reportFolderId: number, label: string) =>
    createReportConfigurationReport(reportFolderId, label) as Promise<ReportConfigurationReportDto>;

export const updateReport = (reportId: number, label: string) =>
    updateReportConfigurationReport(reportId, label) as Promise<ReportConfigurationReportDto>;

export const deleteReport = (reportId: number) =>
    deleteReportConfigurationReport(reportId);

export const cloneReport = (reportId: number, payload: CloneReportConfigurationReportPayload) =>
    cloneReportConfigurationReport(reportId, payload) as Promise<CloneReportConfigurationReportResultDto>;
